import appStatusReducer from './app';
import authReducer from './auth';
import favReducer from './fav';
import groupsReducer from './groups';
import helpReducer from './help';
import logsReducer from './logs';
import postReducer from './post';
import recentReducer from './recent';
import userReducer from './user';

export default {
  app: appStatusReducer,
  auth: authReducer,
  fav: favReducer,
  groups: groupsReducer,
  help: helpReducer,
  logs: logsReducer,
  post: postReducer,
  recent: recentReducer,
  user: userReducer,
};
